
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../auth/useAuth";
import routes from "./helpers/routes";

const PublicRoute = (props) => {
    
  const {user, getUser, isLogged} = useAuth();

  useEffect(()=> {
    getUser();
  }, [getUser])
 
  const location  = useLocation();
  if(location.pathname === '/register'){
    if(!props.emailRegister || !props.tokenRegister) return <Navigate to={'/'} />
  }
  if (isLogged()) return <Navigate to= {routes.dashboard +'/'+ user.role} />;
  return props.children;
};

export default PublicRoute;